import 'flag-icons/css/flag-icons.min.css';

/**
 * The country of an account (ISO 3166-1 alpha-2) as a flag, with the country's
 * name as the tooltip. Renders nothing when the country is unknown.
 *
 * An SVG flag (flag-icons), not the emoji: Windows has no flag emoji and shows
 * two letters instead, and much of the staff is on Windows.
 */
const names = typeof Intl !== 'undefined' && 'DisplayNames' in Intl
  ? new Intl.DisplayNames(['en'], { type: 'region' })
  : null;

export function countryName(code: string): string {
  try { return names?.of(code) || code; } catch { return code; }
}

/** Where the account was last seen, else where it signed up. */
export function accountCountry(a: { last_country?: string | null; signup_country?: string | null }): string | null {
  const code = (a.last_country || a.signup_country || '').trim().toUpperCase();
  return /^[A-Z]{2}$/.test(code) ? code : null;
}

export default function CountryFlag({ code }: { code: string | null | undefined }) {
  const c = (code || '').trim().toUpperCase();
  if (!/^[A-Z]{2}$/.test(c)) return null;
  const name = countryName(c);
  return (
    <span className="country-tag" title={name}>
      <span className={`fi fi-${c.toLowerCase()} country-flag`} role="img" aria-label={name} />
      <span className="country-name">{name}</span>
    </span>
  );
}
